module.exports = __webpack_public_path__ + "static/media/view1.d058ae11.jpg";